import type { SalesOrderLineItemDto } from '../types/salesOrder.types';

// SO line grade code -> PNS grade label, used to read the FO's per-grade price level.
const GRADE_TO_PNS: Record<string, string> = {
  '33': '230', '40': '280', '60': '420', '75': '520', '80': '550',
};

// The FO's default price level for a line's grade ("1"=Base / "2"=Average), or null
// when the FO has no priced line for that grade / no grade. `foMap` is the FO detail's
// perGradePriceLevel (already loaded on the FE — no NetSuite round-trip needed).
export function priceLevelForGrade(
  gradeCode: string | null,
  foMap: Record<string, string> | null | undefined,
): string | null {
  if (!gradeCode || !foMap) return null;
  const pns = GRADE_TO_PNS[gradeCode];
  return pns ? foMap[pns] ?? null : null;
}

// Backfill the FO default price level onto matched lines that don't have one yet.
// Never clobbers a line that already carries a price level (manual pick or prior
// default), so it's safe to call on FO link / draft open / post-extraction.
export function applyFoPriceLevels(
  lines: SalesOrderLineItemDto[],
  foMap: Record<string, string> | null | undefined,
): SalesOrderLineItemDto[] {
  if (!foMap) return lines;
  return lines.map((li) => {
    if (li.priceLevel || !li.matchedItemId || !li.gradeCode) return li;
    const lvl = priceLevelForGrade(li.gradeCode, foMap);
    return lvl ? { ...li, priceLevel: lvl } : li;
  });
}
